export default "__VITE_ASSET__a80a4e8b__"